import { styled } from '@mui/material/styles'
import { IconButton } from 'settle-ui/components/IconButton/IconButton'

export const Button = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(1),
}))
